function NavMobileMenu({ setShowMenu, showDropdown, setShowDropdown }) {
  const toggleDropdown = () => {
    setShowMenu(false);
    setShowDropdown(!showDropdown);
  };

  const handleMenuKeyDown = (event) => {
    if (event.key === "Enter") {
      setShowDropdown(true);
    }
  };

  return (
    <i
      className="hamburger-menu nav-icon"
      onClick={toggleDropdown}
      onKeyDown={handleMenuKeyDown}
      tabIndex="0"
    >
      <div id="nav-icon3">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </i>
  );
}

export default NavMobileMenu;
